import React from "react";

export default function DashboardIcon(props) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="#E2E8F0"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12 4C6.486 4 2 8.486 2 14C1.99871 15.5434 2.35864 17.0656 3.051 18.445C3.221 18.785 3.567 19 3.946 19H20.053C20.432 19 20.779 18.785 20.949 18.445C21.6414 17.0656 22.0013 15.5434 22 14C22 8.486 17.514 4 12 4ZM19.41 17H4.59C4.19924 16.0481 3.99879 15.0289 4 14C4 9.589 7.589 6 12 6C16.411 6 20 9.589 20 14C20.0012 15.0289 19.8008 16.0481 19.41 17Z"
        fill="inherit"
      />
      <path
        d="M10.9387 12.9391C10.726 13.0782 10.5513 13.2681 10.4303 13.4917C10.3094 13.7153 10.2461 13.9654 10.2461 14.2196C10.2461 14.4738 10.3094 14.724 10.4303 14.9475C10.5513 15.1711 10.726 15.361 10.9387 15.5001C11.1068 15.6107 11.295 15.6871 11.4927 15.7248C11.6903 15.7626 11.8935 15.761 12.0905 15.7201C12.2875 15.6792 12.4745 15.5999 12.6408 15.4866C12.8071 15.3734 12.9495 15.2284 13.0597 15.0601L17.0217 9.02211C17.0249 9.01683 17.0266 9.01078 17.0266 9.00461C17.0266 8.99845 17.0249 8.9924 17.0217 8.98711C17.017 8.9799 17.0096 8.97482 17.0012 8.97295C16.9928 8.97109 16.984 8.97258 16.9767 8.97711L10.9387 12.9391Z"
        fill="inherit"
      />
    </svg>
  );
}
